import { Component, computed, inject } from "@angular/core";
import { EarnService } from "@bitwarden/web-vault/app/services/earn/earn.service";
import { EarnLookup } from "@bitwarden/web-vault/app/services/earn/lookup.service";
import { IHeaderAngularComp } from "ag-grid-angular";
import type { IHeaderParams } from "ag-grid-community";

type SelectAllHeaderParams = IHeaderParams & {
  isToggleDisabled?: () => boolean;
};

@Component({
  selector: "app-select-all-header-renderer",
  templateUrl: "./select-all-header.renderer.html",
})
export class SelectAllHeaderRenderer implements IHeaderAngularComp {
  private params!: SelectAllHeaderParams;
  earnService: EarnService = inject(EarnService);
  earnLookup: EarnLookup = inject(EarnLookup);

  isMasked = computed(() => this.earnLookup.isAllRowsMasked());
  disabled = false;

  agInit(params: SelectAllHeaderParams): void {
    this.params = params;
    this.sync();
  }

  refresh(params: SelectAllHeaderParams): boolean {
    this.params = params;
    this.sync();
    return true;
  }

  private sync() {
    this.disabled = !!this.params.isToggleDisabled?.();
  }

  onToggle() {
    this.earnLookup.toggleAllRows();
  }
}
